module.exports = __webpack_public_path__ + "static/media/fruits_17.5784fad7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_17.csv
// module id = 681
// module chunks = 0